import classnames from "classnames";
import React, { type FC, useEffect, useState } from "react";
import AICLayout from "src/components/AICLayout/AICLayout";
import { DocumentListContextProvider } from "src/components/Contexts/DocumentList/Provider";
import { FilterOptionsContextProvider } from "src/components/Contexts/FilterOptions/Provider";
import { PaginationContextProvider } from "src/components/Contexts/PaginationContext";
import ExportButton from "src/components/ExportButton/ExportButton";
import DocumentTypeWarningMessage from "src/components/DocumentTypeWarningMessage";
import BulkOperations from "src/components/Pages/DocumentList/BulkOperations";
import FilterBar from "src/components/Pages/DocumentList/Filters/FilterBar";
import SideBarFilter from "src/components/Pages/DocumentList/Filters/SideBarFilter";
import styles from "../../../styles.module.scss";
import DocumentTable from "./DocumentTable";
import { usePageTitle } from "src/components/Title/usePageTitle";

const DocumentListing: FC = () => {
  const [sidebarVisible, setSidebarVisible] = useState(false);

  useEffect(() => {
    setSidebarVisible(sidebarVisible);
  }, [sidebarVisible]);

  const moreFilterHandler = () => {
    setSidebarVisible(!sidebarVisible);
  };

  usePageTitle("aic_document_list_title_text");

  return (
    <AICLayout>
      <PaginationContextProvider>
        <FilterOptionsContextProvider>
          <DocumentListContextProvider>
            <DocumentTypeWarningMessage />
            <div
              className={classnames(
                styles.ma_10,
                styles.display_flex,
                styles.flex_direction_column
              )}
            >
              <div
                className={classnames(
                  styles.flex,
                  styles.flex_nowrap,
                  styles.flex_direction_row,
                  styles.w_100,
                  styles.justify_space_between
                )}
              >
                <div className={classnames(styles.w_100)}>
                  <div
                    className={classnames(
                      styles.flex,
                      styles.flex_direction_row,
                      styles.flex_nowrap,
                      styles.w_100,
                      styles.align_items_center,
                      styles.justify_space_between
                    )}
                  >
                    <FilterBar moreFilterHandler={moreFilterHandler} />
                  </div>
                  <div
                    className={classnames(
                      styles.flex,
                      styles.justify_space_between,
                      styles.align_items_end
                    )}
                  >
                    <div
                      className={classnames(
                        styles.flex,
                        styles.align_items_center,
                        styles.justify_space_between,
                        styles.w_100,
                        styles.mt_16
                      )}
                    >
                      <BulkOperations />
                      <ExportButton />
                    </div>
                  </div>
                </div>
              </div>
              <DocumentTable />
            </div>
            <SideBarFilter
              visible={sidebarVisible}
              onCancel={() => setSidebarVisible(false)}
              onSubmit={() => setSidebarVisible(false)}
            />
          </DocumentListContextProvider>
        </FilterOptionsContextProvider>
      </PaginationContextProvider>
    </AICLayout>
  );
};

export default DocumentListing;
